import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Autocomplete, TextField } from '@mui/material';

import { Loading } from 'components';
import { useBuildings } from 'pages/buildings/buildings.hook';
import { getBuildingLocation, toQueryString } from 'utils';
import { useReportsPageContext } from './reports-page.context';

export const ReportsBuildingSelector = () => {
  const navigate = useNavigate();
  const { buildingId, start, end } = useReportsPageContext();
  const [loading, buildings] = useBuildings();

  return (
    <Autocomplete
      value={buildingId}
      options={buildings.map((item) => item.id)}
      getOptionLabel={(option) => {
        const building = buildings.find((item) => item.id === option);

        if (building) {
          return getBuildingLocation(building);
        }

        return '';
      }}
      onChange={(_, newValue) => {
        const qs = toQueryString({ building: newValue, start, end });

        navigate(qs ? `?${qs}` : '');
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Building"
          placeholder="Enter search keyword..."
          sx={{ bgcolor: 'white' }}
        />
      )}
      fullWidth
      loading={loading}
      loadingText={<Loading text="Loading buildings..." height={120} />}
    />
  );
};
